export default {
    IMAGES_DATA_KEY: "images",
    AUDIOS_DATA_KEY: "audios",
    SPRITE_SHEETS_DATA_KEY: "spriteSheets",
    SPINE_ANIMATION_DATA_KEY: "spineAnimations",
    images: {
        casinoChipValue005: "src/assets/images/casino_chips/0_05.png",
        casinoChipValue01: "src/assets/images/casino_chips/0_1.png",
        casinoChipValue05: "src/assets/images/casino_chips/0_5.png",
        casinoChipValue1: "src/assets/images/casino_chips/1.png",
        casinoChipValue2_5: "src/assets/images/casino_chips/2_5.png",
        casinoChipValue5: "src/assets/images/casino_chips/5.png",
        casinoChipValue10: "src/assets/images/casino_chips/10.png",
        casinoChipValue25: "src/assets/images/casino_chips/25.png",
        casinoChipValue100: "src/assets/images/casino_chips/100.png",
        smallBetsCasinoChipValue001: "src/assets/images/casino_chips/small_bets/0_01.png",
        smallBetsCasinoChipValue005: "src/assets/images/casino_chips/small_bets/0_05.png",
        smallBetsCasinoChipValue01: "src/assets/images/casino_chips/small_bets/0_1.png",
        smallBetsCasinoChipValue025: "src/assets/images/casino_chips/small_bets/0_25.png",
        smallBetsCasinoChipValue05: "src/assets/images/casino_chips/small_bets/0_5.png",
        smallBetsCasinoChipValue1: "src/assets/images/casino_chips/small_bets/1.png",
        smallBetsCasinoChipValue2_5: "src/assets/images/casino_chips/small_bets/2_5.png",
        smallBetsCasinoChipValue5: "src/assets/images/casino_chips/small_bets/5.png",
        extremelySmallBetsCasinoChipValue0001: "src/assets/images/casino_chips/extremely_small_bets/0_001.png",
        extremelySmallBetsCasinoChipValue0005: "src/assets/images/casino_chips/extremely_small_bets/0_005.png",
        extremelySmallBetsCasinoChipValue001: "src/assets/images/casino_chips/extremely_small_bets/0_01.png",
        extremelySmallBetsCasinoChipValue0025: "src/assets/images/casino_chips/extremely_small_bets/0_025.png",
        extremelySmallBetsCasinoChipValue005: "src/assets/images/casino_chips/extremely_small_bets/0_05.png",
        extremelySmallBetsCasinoChipValue01: "src/assets/images/casino_chips/extremely_small_bets/0_1.png",
        extremelySmallBetsCasinoChipValue025: "src/assets/images/casino_chips/extremely_small_bets/0_25.png",
        extremelySmallBetsCasinoChipValue05: "src/assets/images/casino_chips/extremely_small_bets/0_5.png",
        leftBetAreaButtonBase: "src/assets/images/buttons/betAreas/left/base.png",
        leftBetAreaButtonHover: "src/assets/images/buttons/betAreas/left/hover.png",
        centerBetAreaButtonBase: "src/assets/images/buttons/betAreas/center/base.png",
        centerBetAreaButtonHover: "src/assets/images/buttons/betAreas/center/hover.png",
        rightBetAreaButtonBase: "src/assets/images/buttons/betAreas/right/base.png",
        rightBetAreaButtonHover: "src/assets/images/buttons/betAreas/right/hover.png",
        infoAndHowToPlayCloseBase: "src/assets/images/buttons/infoAndHowToPlayClose/base.png",
        infoAndHowToPlayCloseHover: "src/assets/images/buttons/infoAndHowToPlayClose/hover.png",
        infoAndHowToPlayCloseClick: "src/assets/images/buttons/infoAndHowToPlayClose/click.png",
        infoBase: "src/assets/images/buttons/info/base.png",
        infoHover: "src/assets/images/buttons/info/hover.png",
        infoClick: "src/assets/images/buttons/info/click.png",
        howToPlayButtonBase: "src/assets/images/buttons/howToPlay/base.png",
        howToPlayButtonHover: "src/assets/images/buttons/howToPlay/hover.png",
        howToPlayButtonClick: "src/assets/images/buttons/howToPlay/click.png",
        splitBase: "src/assets/images/buttons/split/base.png",
        splitHover: "src/assets/images/buttons/split/hover.png",
        splitClick: "src/assets/images/buttons/split/click.png",
        splitInActive: "src/assets/images/buttons/split/inActive.png",
        standBase: "src/assets/images/buttons/stand/base.png",
        standHover: "src/assets/images/buttons/stand/hover.png",
        standClick: "src/assets/images/buttons/stand/click.png",
        standInActive: "src/assets/images/buttons/stand/inActive.png",
        changeBetBase: "src/assets/images/buttons/changeBet/base.png",
        changeBetHover: "src/assets/images/buttons/changeBet/hover.png",
        changeBetClick: "src/assets/images/buttons/changeBet/click.png",
        changeBetInActive: "src/assets/images/buttons/changeBet/inActive.png",
        reBetBase: "src/assets/images/buttons/reBet/base.png",
        reBetHover: "src/assets/images/buttons/reBet/hover.png",
        reBetClick: "src/assets/images/buttons/reBet/click.png",
        reBetInActive: "src/assets/images/buttons/reBet/inActive.png",
        payTableArrowBase: "src/assets/images/buttons/arrow/base.png",
        payTableArrowHover: "src/assets/images/buttons/arrow/hover.png",
        payTableArrowClick: "src/assets/images/buttons/arrow/click.png",
        payTableArrowInActive: "src/assets/images/buttons/arrow/inActive.png",
        betPickerArrowLeftBase: "src/assets/images/buttons/betPickerArrowLeft/base.png",
        betPickerArrowLeftHover: "src/assets/images/buttons/betPickerArrowLeft/hover.png",
        betPickerArrowLeftClick: "src/assets/images/buttons/betPickerArrowLeft/click.png",
        betPickerArrowLeftInActive: "src/assets/images/buttons/betPickerArrowLeft/inActive.png",
        betPickerArrowRightBase: "src/assets/images/buttons/betPickerArrowRight/base.png",
        betPickerArrowRightHover: "src/assets/images/buttons/betPickerArrowRight/hover.png",
        betPickerArrowRightClick: "src/assets/images/buttons/betPickerArrowRight/click.png",
        betPickerArrowRightInActive: "src/assets/images/buttons/betPickerArrowRight/inActive.png",
        invisibleBetPickerButton: "src/assets/images/buttons/betPickerInvisible/base.png",
        insureBase: "src/assets/images/buttons/insure/base.png",
        insureHover: "src/assets/images/buttons/insure/hover.png",
        insureClick: "src/assets/images/buttons/insure/click.png",
        insureInActive: "src/assets/images/buttons/insure/inActive.png",
        notInsureBase: "src/assets/images/buttons/doNotInsure/base.png",
        notInsureHover: "src/assets/images/buttons/doNotInsure/hover.png",
        notInsureClick: "src/assets/images/buttons/doNotInsure/click.png",
        notInsureInActive: "src/assets/images/buttons/doNotInsure/inActive.png",
        doubleBase: "src/assets/images/buttons/double/base.png",
        doubleHover: "src/assets/images/buttons/double/hover.png",
        doubleClick: "src/assets/images/buttons/double/click.png",
        doubleInActive: "src/assets/images/buttons/double/inActive.png",
        hitBase: "src/assets/images/buttons/hit/base.png",
        hitHover: "src/assets/images/buttons/hit/hover.png",
        hitClick: "src/assets/images/buttons/hit/click.png",
        hitInActive: "src/assets/images/buttons/hit/inActive.png",
        clearBetsBase: "src/assets/images/buttons/clearBets/base.png",
        clearBetsHover: "src/assets/images/buttons/clearBets/hover.png",
        clearBetsClick: "src/assets/images/buttons/clearBets/click.png",
        clearBetsInActive: "src/assets/images/buttons/clearBets/inActive.png",
        volumeOffBase: "src/assets/images/buttons/volume/offBase.png",
        volumeOffHover: "src/assets/images/buttons/volume/offHover.png",
        volumeOffClick: "src/assets/images/buttons/volume/offClick.png",
        volumeOnBase: "src/assets/images/buttons/volume/onBase.png",
        volumeOnHover: "src/assets/images/buttons/volume/onHover.png",
        volumeOnClick: "src/assets/images/buttons/volume/onClick.png",
        textFieldBackground: "src/assets/images/textFieldBackground.png",
        gameBackground: "src/assets/images/gameBackground.png",
        actionsButtonsBackground: "src/assets/images/actionsButtonsBackground.png",
        dealButtonBase: "src/assets/images/buttons/deal/base.png",
        dealButtonOnHover: "src/assets/images/buttons/deal/hover.png",
        dealButtonOnClick: "src/assets/images/buttons/deal/click.png",
        dealButtonInActive: "src/assets/images/buttons/deal/inActive.png",
        removeAllBetsButton: "src/assets/images/buttons/removeAllBets/base.png",
        removeAllBetsOnHoverButton: "src/assets/images/buttons/removeAllBets/hover.png",
        removeAllBetsButtonOnClick: "src/assets/images/buttons/removeAllBets/click.png",
        removeAllBetsButtonInActive: "src/assets/images/buttons/removeAllBets/inActive.png",
        betPickerPanelBackground: "src/assets/images/betPickerPanelBackground.png",
        lightUnderCards: "src/assets/images/lightUnderCards.png",
        howToPlay1: "src/assets/images/payTable/howToPlay1.png",
        howToPlay2: "src/assets/images/payTable/howToPlay2.png",
        howToPlay3: "src/assets/images/payTable/howToPlay3.png",
        handValueBackground: "src/assets/images/handValueBackground.png",
        betValueBackground: "src/assets/images/betValueBackground.png",
        infoBackground: "src/assets/images/infoBackground.png",
    },
    fonts: {
        RobotoCondensedRegular: "src/assets/fonts/RobotoCondensed-Regular.ttf",
        RobotoMedium: "src/assets/fonts/Roboto-Medium.ttf",
        RobotoRegular: "src/assets/fonts/Roboto-Regular.ttf",
    },
    spriteSheets: {},
    spineAnimations: {
        snackBar: "src/assets/spineAnimations/infoPopupAnimation/PopupAnimation.json",
        cardFront: "src/assets/spineAnimations/staticCardAnimation/staticCardAnimation.json",
        cardTurn: "src/assets/spineAnimations/cardTurnAnimation/cardTurnAnimation.json",
        cardsHand: "src/assets/spineAnimations/cardsHandAnimation/cardsHandAnimation.json",
        betPicker: "src/assets/spineAnimations/betPickerAnimation/betPickerAnimation.json",
        smallBetsBetPicker: "src/assets/spineAnimations/smallBetsBetPickerAnimation/betPickerAnimation.json",
        extremelySmallBetsBetPicker:
            "src/assets/spineAnimations/extremelySmallBetsBetPickerAnimation/betPickerAnimation.json",
        arrow: "src/assets/spineAnimations/arrowAnimation/arrow.json",
        blackjack: "src/assets/spineAnimations/blackjackAnimation/blackjackAnimation.json",
        winInfo: "src/assets/spineAnimations/winInfoAnimation/winInfo.json",
    },
    audios: {
        betValueSmaller: "src/assets/audios/Buttons/BetValue/smaller.ogg",
        betValueBigger: "src/assets/audios/Buttons/BetValue/bigger.ogg",
        buttonClicked: "src/assets/audios/Buttons/button_normal.ogg",
        firstChipPut: "src/assets/audios/Betting/first_chip.ogg",
        nextChipPut: "src/assets/audios/Betting/next_chips.ogg",
        chipsOnWin: "src/assets/audios/Betting/chips_on_win.ogg",
        blackjack: "src/assets/audios/Win/black_jack.ogg",
        youWin: "src/assets/audios/Win/you_win.ogg",
        checkingForBlackjack: "src/assets/audios/option_appers.ogg",
        cardsCollecting: "src/assets/audios/Cards/collecting.ogg",
        cardsDealing: "src/assets/audios/Cards/dealing.ogg",
        nextCard: "src/assets/audios/Cards/next_card.ogg",
        split: "src/assets/audios/Cards/split.ogg",
    },
    loadingScreen: {
        images: {
            loadingScreenLogo: "src/assets/images/loadingScreen/logo.png",
            loadingBarBack: "src/assets/images/loadingScreen/loading_bar_back.png",
            loadingBarCover: "src/assets/images/loadingScreen/loading_bar_cover.png",
        },
    },
};



// WEBPACK FOOTER //
// ./src/app/configs/data.ts